import { getImage } from '@catalogo/service-americanas-common/src/helpers/image';

export const fmtGalleryImages = (allImages = [], video, quantity, selectedImageIndex) => {
  let remainingQuantity;
  let images = allImages;

  if (quantity > 0) {
    remainingQuantity = images.length - quantity;
    images = images.slice(0, quantity);
  }

  const imageListSize = images?.map((image, index) => {
    const thumbnail = getImage(image, 'small');
    const main = getImage(image, 'large');
    const zoom = getImage(image, 'extraLarge');
    const formattedData = { imageListSize: { thumbnail, main, zoom }, isSelected: selectedImageIndex === index };

    if (video && index === 0) {
      formattedData.video = `${video}&autoplay=1`;
    }

    if (quantity === index + 1) {
      formattedData.remainingQuantity = remainingQuantity;
    }

    return formattedData;
  });

  return imageListSize;
};

export const fmtSelectedImage = (galleryImage, selectedImageIndex) => ({
  main: galleryImage[selectedImageIndex]?.imageListSize?.main,
  zoom: galleryImage[selectedImageIndex]?.imageListSize?.zoom,
  video: galleryImage[selectedImageIndex]?.video,
});

export const openModal = history => () => {
  const { pathname, search } = history.location;
  history.replace({ pathname, search, hash: '#modal-gallery' });
};
